import React from 'react';
import './MenuButtons.scss';
import {Link} from 'react-router-dom'

const MenuButtons = () => {
    return (
        <div className="menu-button">
            <Link to="/create" className="menu-button__new">Create New Poll</Link>
            <Link to="/vote" className="menu-button__existing">Access Existing Poll</Link>
            <Link to="/dashboard" className="menu-button__dashboard">View Dashboard</Link>
        </div>
    );
};

export default MenuButtons;